<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Déplacer le dossier sélectionné vers une autre bannettes</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <mat-form-field class="mat-form-field-box">
                <mat-label>Bannette</mat-label>
                <mat-select class="box-selection" [formControl]="boxFormControl" [(ngModel)]="data.boxId" required>
                    @for (boxGroup of boxGroupInfo; track boxGroup.id) {
                        <mat-optgroup [label]="boxGroup.name">
                            @for (box of boxGroup.boxes; track box.id) {
                                <mat-option [value]="box.id" [disabled]="box.id === currentBoxId">
                                    {{ box.name }}
                                </mat-option>
                            }
                        </mat-optgroup>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-comment">
                <mat-label>Commentaire</mat-label>
                <input matInput [formControl]="commentFormControl" [(ngModel)]="data.comment" autocomplete="off" />
            </mat-form-field>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="data" [disabled]="!boxFormControl.valid">Valider</button>
    </mat-card-actions>
</mat-card>
